export default "__VITE_ASSET__KCqdlwQt__"